import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';
import { Route, Switch, useParams, useLocation, useHistory } from 'react-router-dom';

import MainLayout from 'components/Layouts/Main';
import { ACC_ID } from 'constants/routes';
import { useAppsignalAdminContext } from 'hooks/appsignalContexts/useAppsignalAdminContext';
import { usePendingFilesDownloading } from 'hooks/usePendingFilesDownloading';
import { accountIdSelector } from 'store/user/selectors';

import AdminRoutes from './Admin';

/**
 * Checks whether the accId in the URL matches the accId stored in redux
 * If it's not the case updates the URL replacing the unknown accId with the accId stored in redux
 */
const useURLAccountIdChecker = () => {
  const history = useHistory();
  const location = useLocation();
  const urlParams = useParams();
  const accId = useSelector(accountIdSelector);

  useEffect(() => {
    if (urlParams.accountId !== accId) {
      const pathnameSegments = location.pathname.split('/');
      pathnameSegments[2] = accId; // replace unknown id; assume that accId at index 2 TODO: is there a better way to update URL?
      history.push(pathnameSegments.join('/') + location.search + location.hash);
    }
  }, []);
};

function AppRoutes() {
  usePendingFilesDownloading();
  useURLAccountIdChecker();
  useAppsignalAdminContext();

  return (
    <MainLayout>
      <Switch>
        <Route path={ACC_ID} component={AdminRoutes} />
      </Switch>
    </MainLayout>
  );
}

export default AppRoutes;
